import types from '../types.js';

export const loadSites = () => {
  return { type: types.LOAD_SITES, payload: null };
};

export const selectSite = payload => {
  return { type: types.SELECT_SITE, payload };
};

export const getSelectedSite = state => {
  return state.siteReducer.selectedSite;
};

export const getSites = state => {
  return state.siteReducer.sites;
};
